export const FOLDER = 'Folder'
export const NEW_ACTIVITY_FOLDER = 'New Activity Folder'
export const NEW_LEARNING_AREA = 'New Learning Area'
export const UPLOAD_CONTENT_FOLDER = 'Upload Content Folder'
export const REALM = 'Realm'
export const TOPIC = 'Topic'
export const KEYCONCEPT = 'Key Concept'
export const EDUCATIONALUSE = 'Educational Use'
export const AGERANGE = 'Age Range'
export const SCIENTIST = 'Scientist'
export const FIELD = 'Field'
export const INSTITUTION = 'Institution'
export const COUNTRY = 'Country'
export const QUEST_TYPE = [
    {
        id: 1,
        name: 'animation',
        bgc: '#36cfc9',
    },
    {
        id: 2,
        name: 'book',
        bgc: '#17BDF1',
    },
    {
        id: 3,
        name: 'game',
        bgc: '#6AC353',
    },
    {
        id: 4,
        name: 'quiz',
        bgc: '#FABE87',
    },
    {
        id: 5,
        name: 'song',
        bgc: '#fff566',
    },
    {
        id: 6,
        name: 'other',
        bgc: '#d3adf7',
    },
]
export const LEARNING_AREA = [
    {
        id: 1,
        name: 'English',
    },
    {
        id: 2,
        name: 'Mathematics',
    },
    {
        id: 3,
        name: 'Science',
    },
    {
        id: 4,
        name: 'Humanities and Social Sciences',
    },
    {
        id: 5,
        name: 'The Arts',
    },
    {
        id: 6,
        name: 'Technologies',
    },
    {
        id: 7,
        name: 'Health and Physical Education',
    },
    {
        id: 8,
        name: 'Languages',
    },
]
export const YEAR_LEVEL = [
    {
        id: 1,
        name: 'Year 1',
    },
    {
        id: 2,
        name: 'Year 2',
    },
    {
        id: 3,
        name: 'Year 3',
    },
    {
        id: 4,
        name: 'Year 4',
    },
    {
        id: 5,
        name: 'Year 5',
    },
    {
        id: 6,
        name: 'Year 6',
    },
    {
        id: 7,
        name: 'Year 7',
    },
    {
        id: 8,
        name: 'Year 8',
    },
    {
        id: 9,
        name: 'Year 9',
    },
    {
        id: 10,
        name: 'Year 10',
    },
    {
        id: 11,
        name: 'Year 11',
    },
    {
        id: 12,
        name: 'Year 12',
    },
    {
        id: 13,
        name: 'Foundation',
    },
    {
        id: 0,
        name: 'All',
    },
]
export const AUDIENCE_ROLE = [
    {
        id: 1,
        name: 'School',
        // color: '#17BDF1',
    },
    {
        id: 2,
        name: 'Teacher',
        // color: '#6AC353',
    },
    {
        id: 3,
        name: 'Parent',
        // color: '#DEA0DF',
    },
    {
        id: 4,
        name: 'Student',
        // color: '#FABE87',
    },
]
export const GENERAL_CAPABILITY = [
    {
        id: 1,
        name: 'Literacy',
    },
    {
        id: 2,
        name: 'Numeracy',
    },
    {
        id: 3,
        name: 'Information and  Communication Technology(ICT) Capability',
    },
    {
        id: 4,
        name: 'Critical and Creative Thinking',
    },
    {
        id: 5,
        name: 'Personal and Social Capability',
    },
    {
        id: 6,
        name: 'Ethical Understanding',
    },
    {
        id: 7,
        name: 'Intercultural Understanding',
    },
    {
        id: 0,
        name: 'All',
    },
]
